// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setUserFields from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import useCheckboxPicker from "@store/Library/Components/Reporting/ModalPicker/useCheckboxPicker";

import React, { useEffect } from "react";

interface ReportingRolesProps {
    optionalSelectedItemsChangeCallback?: (items: string[]) => void;
    selectedItemsStringOverride?: string;
}
export const ReportingRoles: React.FC<ReportingRolesProps> = ({
    optionalSelectedItemsChangeCallback,
    selectedItemsStringOverride,
}) => {
    const { selectedItems, setSelectedItems, toggleItem, toggleAllItems } = useCheckboxPicker();
    const isReportingEnabled = useAppSelector(
        state => state.context.settings?.settingsCollection?.reportingSettings?.isReportingEnabled,
    );
    const dispatch = useAppDispatch();
    const roleList: { [key: string]: string } = JSON.parse(
        useAppSelector(state => state.data.accounts.byId["current"]?.properties?.availableReportingRoles ?? "{}"),
    );
    const editingUser = useAppSelector(state => getCurrentEditingUser(state));
    const data = Object.values(roleList);

    const selectedItemsString = selectedItemsStringOverride ?? editingUser?.properties?.reportingRoles ?? "";
    const getNewValues = (newItems: string[]) => {
        const newValues: string[] = [];
        data.forEach((role, index) => {
            if (newItems.includes(role)) {
                newValues.push(roleListKeys[index]);
            }
        });
        return newValues;
    };
    useEffect(() => {
        if (!selectedItemsString) {
            setSelectedItems([]);
            return;
        }
        const selectedItemsArray = selectedItemsString.split(",");
        const selectedItemsKeys = selectedItemsArray.map(item => roleList[item]);
        setSelectedItems(selectedItemsKeys);
    }, [roleList, selectedItemsString, setSelectedItems]);

    const roleListKeys = Object.keys(roleList);
    if (!data.length) {
        return null;
    }

    const handleSelectedItemsChange =
        optionalSelectedItemsChangeCallback ||
        ((newItems: string[]) =>
            dispatch(
                setUserFields({ properties: { reportingRoles: newItems.join(",") } } as {
                    properties: { reportingRoles: string };
                } as any),
            ));

    const handleToggleItem = (item: string) => {
        const newItems = toggleItem(item);

        handleSelectedItemsChange(getNewValues(newItems));
    };
    const handleToggleAllItems = (ids: string[]) => {
        const newItems = toggleAllItems(ids);
        handleSelectedItemsChange(getNewValues(newItems));
    };
    if (!isReportingEnabled) {
        return null;
    }
    return (
        <>
            <ModalPicker
                // eslint-disable-next-line spire/avoid-dynamic-translate
                header={translate("Reporting roles")}
                data={data}
                customPlaceholder={translate("Add reporting roles")}
                selectedItems={selectedItems}
                toggleItem={handleToggleItem}
                toggleAllItems={handleToggleAllItems}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ReportingRoles,
    definition: {
        group: "User Setup",
        displayName: "Reporting Roles",
        allowedContexts: ["UserSetupPage"],
    },
};

export default widgetModule;
